var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('snackbar-queue',{attrs:{"items":_vm.items},on:{"remove":_vm.removeItem}})}
var staticRenderFns = []

export { render, staticRenderFns }